module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAABL0lEQVRoQ+3YzQ2DMAyG4QQW6AqdoGIDqgxSdaOOwB4gxAiM0BEYgOCKA1IP7YHY/gxSOPPzPjGHgHcnP/zJ+10GWE8wTyBPgLkC+RVKXcAQwqsoiqZt2zH1Hut1JhMIITTe+wcRTTHG6zAMUyoCDtji1+BlWZ593zep8fAJSMdDARrxMIBWPASgGa8O0I5XBSDi1QCoeBUAMl4cgI4XBVjEiwGs4kUAlvFsgHU8C3CE+GRAXdeXsiwH7/2NiN4xxoqzpzfZTn8jnHPjPM93CwTrg+YICBZgHb01gg2wRogALBFiACuEKMACIQ5AI1QASIQaAIVQBSAQ6gBtBASgiYABtBBQwC9E13WVyXaa89BtA0hEr1P9Xueg/10Lf4WkERkgvaJ775cnsHfFpM//ACXrIECSzrxSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow2prev.png
// module id = JoCF
// module chunks = 1